module.exports = __webpack_public_path__ + "img/germany.00b72545.svg";